export default __webpack_public_path__ + "images/loggedout/home/modularPage/modular_ellipse2-07b23489a90698d55a806f6b2d346bb1.png";